import { ReactNode } from 'react';
import classNames from 'classnames';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import styles from './AiAssistant.module.scss';

type Props = {
  children: ReactNode;
};

// The assistant's lane: its avatar, and the column everything the turn produced
// stacks into. Shared by every assistant-side row — the answer bubble, tool
// activity, and the failure banner — so one turn reads as one avatar group
// whatever it ended up producing.
export default function AssistantRow({ children }: Props) {
  return (
    <div className={classNames(styles.messageRow, styles.messageRowAssistant)}>
      <div className={classNames(styles.avatar, styles.avatarAssistant)}>
        <MaterialIcon icon="auto_awesome" symbolsOutlined size="md-20" />
      </div>
      <div className={styles.messageContentColumn}>{children}</div>
    </div>
  );
}
